module.exports = __webpack_public_path__ + "img/flag_goals.1baf2f81.svg";